import axios from "@/common/request";
import {
  IDoPraise,
  IGetChatRoom,
  IGetDetail,
  IGetJsonDetail,
  IGetFloating,
  IGetGiftRecord,
  IGetLiveList,
  IGetLivePoint,
  IGetLiveRedpacket,
  IGetLiveRoom,
  IGetShareInfo,
  IGiftTips,
  ILiveExchange,
  ILiveReply,
  IGetLiveShare,
  IResponse,
  IHosts,
  IConfigJson,
  ICount,
  IAppConfig,
  WeChartUserInfoRes,
  IcommentSave,
  IuserBindPhone,
  appInfoRes,
  HlxDataCollect,
  HlxDataCollectVideo,
  HlxDataCollectShare
} from "./types";
import store from "@/store";
import { getminute } from "@/common/utils";

class RequestIndex {
  getAppInfo(appId: any) {
    throw new Error("Method not implemented.");
  }
  private get appId() {
    return store.state.appId;
  }

  private get token() {
    return store.state.token;
  }

  private get sessionId() {
    return store.state.sessionId;
  }

  private get infoClassifyId() {
    return store.state.infoClassifyId;
  }

  /**
   * 增加浏览量
   * @param infoClassifyId infoClassifyId
   */

  // getCount(infoClassifyId: string, url: string): Promise<IResponse> {
  //   return axios.post(`${url}info/v2/addViewCount.html`, {
  //     appId: this.appId,
  //     sourceId: infoClassifyId,
  //     sourceType: 1
  //   });
  // }
  getCount(): Promise<IResponse> {
    return axios.get(
      process.env.VUE_APP_BASE_API +
        `getAndIncrCount.html?infoClassifyId=${this.infoClassifyId}&appId=${this.appId}`
    );
  }

  /**
   * 通过ID获取当前直播间全局配置文件
   */
  getConfigJsonById(id: string): Promise<IConfigJson> {
    return axios.get(
      `https://h5cloud.cqliving.com/statics/live/data/${
        process.env.VUE_APP_ENV
      }/${id}.json?t=${getminute()}`
    );
  }

  /**
   * 获取全局配置文件
   */
  getConfigJson(): Promise<IConfigJson> {
    return axios.get(
      `https://h5cloud.cqliving.com/statics/live/data/${
        process.env.VUE_APP_ENV
      }/config.json?t=${getminute()}`
    );
  }

  /**
   * 获取浏览量、点赞量
   */
  getCountJson(): Promise<ICount> {
    return axios.get(
      `https://h5cloud.cqliving.com/statics/live/data/${
        process.env.VUE_APP_ENV
      }/${this.infoClassifyId}/index.json?t=${getminute()}`
    );
  }

  /**
   * 获取直播详情
   */
  getDetailByJson(): Promise<IGetJsonDetail> {
    return axios.get(
      `https://h5cloud.cqliving.com/statics/live/data/${
        process.env.VUE_APP_ENV
      }/${this.infoClassifyId}.json?t=${getminute()}`
    );
  }

  /**
   * 获取直播详情
   * @param infoClassifyId infoClassifyId
   */
  detail(infoClassifyId: string): Promise<IGetDetail> {
    return axios.get(
      process.env.VUE_APP_ZWY_LIVE + `/live/detail/${infoClassifyId}`,
      {
        params: {
          token: this.token
        }
      }
    );
  }

  /**
   * 获取app配置
   */
  getAppConfig(): Promise<[IAppConfig]> {
    // return axios.post(process.env.VUE_APP_ZWY_LIVE + "/getAppConfig", {
    //   appId: this.appId
    // });
    return axios.get(
      `https://imagecdn${
        process.env.VUE_APP_ENV == "prod" ? "" : "test"
      }.cqliving.com/${
        process.env.VUE_APP_ENV
      }/app/news/Config/global/appInfoConfigList.json?t=${getminute()}`,
      {}
    );
  }

  /** 获取app信息 */
  getAppInfoList(): Promise<appInfoRes> {
    return axios.get(
      `https://h5cloud.cqliving.com/statics/h5/res/getAppInfoList.json?t=${getminute()}`,
      {}
    );
  }
  /**
   * 获取主持人列表
   * @param infoClassifyId
   */
  getHosts(infoClassifyId: string): Promise<IHosts> {
    return axios.post("/live/hosts.html", {
      appId: this.appId,
      infoClassifyId
    });
  }

  /**
   * 获取礼物列表
   */
  giftList(): Promise<IGetLiveList> {
    return axios.post(process.env.VUE_APP_ZWY_LIVE + "/live/live_list", {
      appId: this.appId
    });
  }

  /**
   * 用户可用总积分接口
   */
  livePoint(): Promise<IGetLivePoint> {
    return axios.post("/live/live_point.html", {
      appId: this.appId,
      token: this.token,
      sessionId: this.sessionId
    });
  }

  /**
   * 获取唤醒app信息接口
   */
  getShareInfo(): Promise<IGetShareInfo> {
    return axios.post(process.env.VUE_APP_ZWY_LIVE + "/getShareInfo", {
      appId: this.appId
    });
  }

  /**
   * 获取兑奖记录
   * @param lastId 最后一条记录的ID
   */
  getGiftRecord(lastId: string): Promise<IGetGiftRecord> {
    return axios.post("/live/live_records.html", {
      lastId,
      token: this.token
    });
  }

  /**
   * 直播间列表
   * @param infoClassifyId 资讯ID
   * @param lastReplyId 最后的评论id
   * @param lastId lastId
   * @param lastSortNo 最后一条数据的排序号
   * @param lastCreateTime 最后一条数据时间
   * @param hostIds 筛选主持人
   * @param sort 不为空 升序  默认降序
   */
  getLiveRoom(
    infoClassifyId: string,
    lastReplyId?: number,
    lastId?: number,
    lastSortNo?: number,
    lastCreateTime?: string,
    hostIds?: string[],
    sort = "desc"
  ): Promise<IGetLiveRoom> {
    return axios.post(process.env.VUE_APP_ZWY_LIVE + "/live/live_room", {
      appId: this.appId,
      token: this.token,
      infoClassifyId,
      lastReplyId,
      lastId,
      lastSortNo,
      lastCreateTime,
      hostIds,
      sort: sort
    });
  }

  /**
   * 聊天室列表
   * @param infoClassifyId 资讯ID
   * @param lastReplyId 最后的评论id
   * @param lastCreateTime 最后的评论时间
   */
  getChatRoom(
    infoClassifyId: string,
    lastCreateTime: string,
    lastReplyId?: number,
    v?: string
  ): Promise<IGetChatRoom> {
    return axios.get(process.env.VUE_APP_ZWY_LIVE + "/live/chat_room", {
      params: {
        infoClassifyId,
        appId: this.appId,
        lastReplyId,
        lastCreateTime,
        token: this.token,
        v
      }
    });
  }

  /**
   * 点赞
   * @param userId 被点赞用户 id
   * @param title 资讯标题/评论内容
   * @param infoClassifyId 资讯ID
   */
  doPraise(
    userId: string,
    title: string,
    infoClassifyId: string,
    type: number,
    sourceType = 50
  ): Promise<IDoPraise> {
    return axios.post("/doPraise.html", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      userId,
      title,
      v: 1,
      type,
      sourceId: infoClassifyId,
      sourceType
    });
  }

  /**
   * 评论
   */
  commentSave(data: {
    isAnonymous: boolean;
    content: string;
    columnsType: number;
    sourceType: string;
    sourceId: string;
    passiveReplyName?: string;
    passiveReplyId?: number | string;
  }): Promise<IcommentSave> {
    return axios.post("/commentSave.html", {
      appId: this.appId,
      sessionId: this.sessionId,
      token: this.token,
      ...data
    });
  }

  /**
   * 判断红包状态接口
   * @param id id
   * @param nickname 当前红包主持人名称
   * @param avatar 当前红包主持人头像
   */
  liveRedpacket(
    id: string,
    nickname: string,
    avatar: string
  ): Promise<IGetLiveRedpacket> {
    return axios.post("/live/live_redpacket/status.html", {
      liveDetailId: id,
      token: this.token,
      nickname,
      avatar
    });
  }

  /**
   * 开启红包
   * @param liveDetailId ID
   */
  openRedpacket(liveDetailId: string): Promise<IGetLiveRedpacket> {
    return axios.post("/live/live_redpacket/openRedpacket.html", {
      liveDetailId,
      token: this.token
    });
  }

  /**
   * 获取评论列表（弹幕）
   * @param infoClassifyId 新闻id
   * @param lastId 最新评论 和 下拉都必须传最后一条id
   */
  liveReply(infoClassifyId: string, lastId?: number): Promise<ILiveReply> {
    return axios.post(process.env.VUE_APP_ZWY_LIVE + "/live/live_reply", {
      infoClassifyId,
      desc: true,
      lastId
    });
  }

  /**
   * 用户赠送礼物接口
   * @param giftId 礼物id
   * @param sum 礼物送的数量
   * @param informationId 新闻详情id
   * @param titile 新闻标题
   */
  liveExchange(
    giftId: number,
    sum: number,
    informationId: number,
    titile: string
  ): Promise<ILiveExchange> {
    return axios.post("/live/live_exchange.html", {
      token: this.token,
      giftId,
      sum,
      informationId,
      titile
    });
  }

  /**
   * 其他用户展示的礼物
   * @param informationId 新闻ID
   * @param interval 间隔
   */
  giftTips(informationId: string, interval: number): Promise<IGiftTips> {
    return axios.post("/live/gift_tips.html", {
      token: this.token,
      informationId,
      interval
    });
  }

  /**
   * 浮窗列表
   * @param infoClassifyId infoClassifyId
   */
  floating(infoClassifyId: string): Promise<IGetFloating> {
    return axios.post(process.env.VUE_APP_ZWY_LIVE + "/live/floating", {
      infoClassifyId
    });
  }

  /**
   * 直播分享
   */
  liveShare(infoClassifyId: string): Promise<IGetLiveShare> {
    return axios.post(process.env.VUE_APP_ZWY_LIVE + "/live/live_share", {
      infoClassifyId,
      appId: this.appId
    });
  }

  /**
   * 分享点赞
   * @param id id
   * @param title 标题
   * @param sourceType sourceType
   */
  doPraiseShare(
    id: string,
    title: string,
    sourceType: number
  ): Promise<IResponse> {
    return axios.post("/doPraiseShare.html", {
      appId: this.appId,
      title: title,
      v: "1",
      type: "0", //0点赞1评论(暂不支持评论)
      sourceId: id,
      sourceType: sourceType //短视频41
    });
  }

  /**
   * 用户评论状态
   * @param id id
   * @param sourceType sourceType
   */
  replyUserStatus(id: string, sourceType: string): Promise<IResponse> {
    console.log(id, sourceType);
    return axios.post("/reply/user/status.html", {
      appId: this.appId,
      token: this.token,
      sourceId: id,
      sourceType: sourceType
    });
  }

  /**
   * 获取慢直播视频列表
   * @param infoClassifyId
   */
  getSlowDetailApi(infoClassifyId: string): Promise<IGetDetail> {
    return axios.get(`/live/detail/slow/${infoClassifyId}.html`, {
      params: {
        token: this.token
      }
    });
  }

  /**
   * 获取微信授权用户信息
   * @param code: string; //微信用户code
   * @param weChatId number; //微信公众号id
   * @param appId string | number;
   */
  weChatAuthor({
    code,
    weChatId
  }: {
    code: string;
    weChatId: number;
  }): Promise<WeChartUserInfoRes> {
    return axios.get(process.env.VUE_APP_NEWACT + "/weChat/userInfo", {
      params: {
        appId: 1,
        code: code,
        weChatId: weChatId,
        registSourceType: "live"
      }
    });
  }
  /**
   * 发送验证码
   * @param phone 手机号
   */
  sendvalidcode(phone: string): Promise<IResponse> {
    return axios.post(process.env.VUE_APP_NEWACT + "/user/getCaptcha", {
      appId: "16",
      type: "20",
      phone
    });
  }
  /**
   * 绑定手机号
   * @param openId openId
   * @param phone 手机号
   * @param smsCode 短信验证码
   */
  userBindPhone({
    openId,
    phone,
    smsCode
  }: {
    openId: string;
    phone: string;
    smsCode: string;
  }): Promise<IuserBindPhone> {
    return axios.post(
      process.env.VUE_APP_NEWACT + "/weChat/userBindPhoneCaptcha",
      {
        openId,
        phoneNo: phone,
        appId: "16",
        captcha: smsCode
      }
    );
  }
  /** ----------华龙芯问政埋点-------- */
  // 浏览量埋点接口
  getHlxNewsRecordCount(params: HlxDataCollect) {
    return axios.post(process.env.VUE_APP_HLX_API + "/news/browse", params);
  }
  // 浏览时长埋点接口
  getHlxNewsRecordTime(params: HlxDataCollect) {
    return axios.post(process.env.VUE_APP_HLX_API + "/news/browseTime", params);
  }
  // 视频时长埋点接口
  getHlxNewsRecordVideo(params: HlxDataCollectVideo) {
    return axios.post(process.env.VUE_APP_HLX_API + "/video/view_count/app", [
      params
    ]);
  }
  // app/微信分享埋点接口
  getHlxNewsRecordShare(params: HlxDataCollectShare) {
    return axios.post(process.env.VUE_APP_HLX_API + "/share", params);
  }
  // 重要保障的直播新闻id
  getStaticJson() {
    return axios.get(
      `https://h5cloud.cqliving.com/zwy/live-config/static.json?t=${getminute(
        10
      )}`
    );
  }
  // 重要保障的直播新闻id的直播间
  getStaticLiveRoom(id: string) {
    return axios.get(
      `https://h5cloud.cqliving.com/zwy/live-config/liveRoom/${id}.json?t=${getminute()}`
    );
  }
}
export default new RequestIndex();
